<template>
	<div class="pwd-line">
		<input ref="pwdInput" type="tel" v-model="pwd" maxlength="6" class="invisible-password" @input="inputChange"/>
		<p @click="selectPwdInput" class="letters">
			<span class="placeholder-text">{{placeholder}}</span>
			<span v-for="(letter,index) in letters" class="num" :class="{active:!!letter}" :key="index">{{letter}}</span>
		</p>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				pwd: ''
			}
		},
		computed:{
			letters(){
				const len = this.pwd.length;
				return this.pwd.split("").concat(new Array(6-len));
			},
			placeholder(){
				return this.pwd.length ? '' : '请输入发送至手机的验证码'
			}
		},
		methods: {
			inputChange(event){
				this.$emit('getPwd', this.pwd);
			},
			clear(){
				this.pwd = '';
			},
			selectPwdInput(){
				this.$refs['pwdInput'].focus();
			},
			sendCode(){
				this.$emit('sendCode');
			}
		}
	}
</script>

<style scoped>
	.pwd-line{
		position: relative;
	}

	.letters{
		display: flex;
		padding-right:220px;
		position: relative;
	}

	input[type='tel'].invisible-password{
		padding-left: .1rem;
		border: none;
		position: absolute;
		height: .8rem;
		font-size: .22rem;
		color: #fff;
		text-indent: -999em;
		margin-left: -100%;
	}

	.num{
		flex:1;
		text-align: center;
		border-bottom:4px solid #d8d8d8;
		margin-right:15px;
		height: 66px;
		font-size:42px;
	}
	.num.active{
		border-bottom:4px solid #333;
	}
	.placeholder-text{
		position: absolute;
		top: 10px;
		left: 0;
		height:66px;
		font-size: 26px;
		color: #bfbfbf;
		padding-right: 2.2rem;
		background: transparent;
		border: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/pwdLine/pwd-line.vue